import { ChangeDetectionStrategy, Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Activity } from '@app/core/models';
import { SHARED_MODULES } from '@app/shared';
import { NgxCurrencyConfig, NgxCurrencyDirective, NgxCurrencyInputMode } from 'ngx-currency';

@Component({
  selector: 'app-modal-review-score',
  imports: [SHARED_MODULES, NgxCurrencyDirective],
  templateUrl: './modal-review-score.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ModalReviewScoreComponent),
      multi: true,
    },
  ],
})
export class ModalReviewScoreComponent implements ControlValueAccessor {
  @Input('activity') public activity: any;
  @Output() public update = new EventEmitter<Activity>();
  @Output() public blur = new EventEmitter<void>();
  private initialValue: any = null;
  private hasChanged: boolean = false;

  constructor() {}
  public score: any = null;
  protected onTouched = () => true;

  protected changeValue = (_: any) => true;

  public writeValue(value: any): void {
    this.score = value;
    if (this.initialValue === null) {
      this.initialValue = value;
    }
  }

  public registerOnChange(fn: any): void {
    this.changeValue = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public onValueChange(value: any): void {
    this.score = value;
    this.changeValue(value);
    this.hasChanged = value !== this.initialValue;
    this.onTouched();
  }

  public handleBlur() {
    if (this.hasChanged) {
      this.blur.emit();
      this.hasChanged = false;
    }
  }

  public get scoreOptions(): NgxCurrencyConfig {
    return {
      align: 'right',
      allowNegative: false,
      allowZero: true,
      decimal: ',',
      precision: 2,
      prefix: '',
      suffix: '',
      thousands: '.',
      nullable: true,
      min: 0,
      max: this.activity.score,
      inputMode: NgxCurrencyInputMode.Financial,
    };
  }
}
